import moment from "moment-jalaali";

/**
 * Universal Shamsi (Jalali) date/time converter.
 * Supports:
 * - Epoch in seconds (e.g. 1729584620 or "1729584620")
 * - Epoch in milliseconds (e.g. 1729584620000 or "1729584620000")
 * - Legacy space-separated Shamsi string (e.g. "1403/08/01 14:30:00")
 * - ISO string or standard JS Date
 */
export const splitJalaliDateTime = (rawDate) => {
  if (rawDate === undefined || rawDate === null || rawDate === "") {
    return { date: "", time: "", full: "" };
  }

  const str = String(rawDate).trim();

  // 1. Numeric Unix Epoch (seconds or milliseconds)
  if (/^\d+$/.test(str)) {
    let num = Number(str);
    // If > 9999999999, it's milliseconds
    if (num > 9999999999) {
      num = Math.floor(num / 1000);
    }
    const m = moment.unix(num);
    if (m.isValid()) {
      const date = m.format("jYYYY/jMM/jDD");
      const time = m.format("HH:mm");
      return {
        date,
        time,
        full: `${date} ${time}`,
      };
    }
  }

  // 2. Legacy Shamsi string with space like "1403/08/01 14:30:00"
  if (str.includes(" ")) {
    const parts = str.split(" ");
    const date = parts[0] || "";
    // If time has seconds (e.g. 14:30:00), take HH:mm
    const rawTime = parts[1] || "";
    const timeParts = rawTime.split(":");
    const time =
      timeParts.length >= 2 ? `${timeParts[0]}:${timeParts[1]}` : rawTime;

    return {
      date,
      time,
      full: `${date} ${time}`,
    };
  }

  // 3. Fallback: Parse with moment (ISO string or standard date)
  const m = moment(str);
  if (m.isValid()) {
    const date = m.format("jYYYY/jMM/jDD");
    const time = m.format("HH:mm");
    return {
      date,
      time,
      full: `${date} ${time}`,
    };
  }

  // Fallback if unparseable
  return { date: str, time: "", full: str };
};

/**
 * Format date for legacy convertDateToJalaliHandler callers
 */
export const convertDateToJalaliHandler = (rawDate) => {
  const { date, time } = splitJalaliDateTime(rawDate);
  if (!date && !time) return "";
  if (!time) return date;
  return `${time} - ${date}`;
};
